<template>
  <div class="agents-userlist">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入手机号查找"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <!-- <FormItem>
                  <Button type="success" @click="createAgentTradesMan()">新增</Button>
          </FormItem>-->
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>

    <Modal v-model="showModalStatus"
           title="添加代理商"
           @on-ok="ok"
           :width="800">
      <Form :model="search_s"
            ref="search_s"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <Table border
             :columns="columns2"
             ref="selection"
             :data="columns2List"
             :loading="dataloading"
             @on-selection-change="handleSelectRow()"></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page ref="listPage1"
                :total="pages1.total"
                :current="pages1.page"
                :page-size="pages1.size"
                show-elevator
                show-total
                @on-change="changePage1()"></Page>
        </div>
      </div>
    </Modal>

    <!-- 商家 弹出 -->
    <Modal v-model="showModalStatus3"
           title="分销比例"
           @on-ok="editAgent('dataInfoValidate')"
           :loading="loading">
      <span style="color:red;">*园区服务费，按已成交金额核算</span>
      <Form :model="dataInfo"
            ref="dataInfoValidate"
            :rules="dataInfoValidate"
            action="javascript:void(0)"
            :label-width="80">
        <FormItem label="云支付分销比例"
                  prop="underline_fx">
          <Input v-model="dataInfo.underline_fx"
                 placeholder="输入云支付分销比例"
                 style="width:120px"></Input>%
        </FormItem>
        <FormItem label="商城分销比例"
                  prop="on_fx">
          <Input v-model="dataInfo.on_fx"
                 placeholder="输入商城分销比例"
                 style="width:120px"></Input>%
        </FormItem>
      </Form>
    </Modal>
    <!--编辑信息-->
    <Drawer :title="title"
            v-model="showModalStatus4"
            width="600"
            :mask-closable="false"
            :styles="styles">
      <Form :model="agents"
            :label-width="60"
            ref="agentsValidate"
            :rules="agentsValidate">
        <FormItem label="uuid"
                  label-position="top">{{ agents.id }}</FormItem>
        <FormItem label="昵称"
                  label-position="top">{{ agents.nickname }}</FormItem>
        <FormItem label="手机号"
                  label-position="top">{{ agents.phone }}</FormItem>
        <FormItem label="姓名"
                  label-position="top"
                  prop="name">
          <Input v-model="agents.name"></Input>
        </FormItem>
        <FormItem label="入驻类型"
                  label-position="top">
          <Select v-model="agents.in_type"
                  clearable
                  filterable
                  placeholder="入驻类型">
            <Option :value="0">个人</Option>
            <Option :value="1">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="代理类型"
                  label-position="top"
                  prop="type">
          <Select v-model="agents.type"
                  clearable
                  filterable
                  placeholder="代理类型">
            <Option :value="1">导游</Option>
            <Option :value="2">民宿</Option>
            <Option :value="3">景点</Option>
          </Select>
        </FormItem>
        <FormItem label="简介"
                  prop="describe">
          <Input v-model="agents.describe"
                 type="textarea"
                 :rows="4"
                 placeholder="简介..."></Input>
        </FormItem>
        <FormItem label="身份证正面照"
                  prop="imageface">
          <upload-thumb v-model="agents.imageface"
                        ref="imagefaceuploadthumb"
                        :defaultList="imagefacethumblist"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照"
                  prop="imageback">
          <upload-thumb v-model="agents.imageback"
                        ref="imagebackuploadthumb"
                        :defaultList="imagebackthumblist"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="营业执照照片"
                  prop="company_photo">
          <upload-thumb v-model="agents.company_photo"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="审核状态"
                  label-position="top">
          <Select v-model="agents.status"
                  clearable
                  filterable
                  placeholder="审核状态">
            <Option :value="0"
                    :key="0">待审核</Option>
            <Option :value="1"
                    :key="1">通过审核</Option>
            <Option :value="2"
                    :key="2">未通过审核</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus4 = false">取消</Button>
        <Button type="primary"
                @click="editagentinfo('agentsValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "agents-userlist",
  data () {
    const validateUnderlineFx = (rule, value, callback) => {
      if (this.dataInfo.underline_fx === "") {
        callback(new Error("请输入云支付分销比例"));
      } else {
        callback();
      }
    };
    const validateOnFx = (rule, value, callback) => {
      if (this.dataInfo.on_fx === "") {
        callback(new Error("请输入商城分销比例"));
      } else {
        callback();
      }
    };
    return {
      id: null, // 页面agentid
      loading: true,
      dataloading: true,
      title: "",
      isable: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      agents: {},
      imagefacethumblist: [], // 身份证是正面
      imagebackthumblist: [], // 身份证反面
      thumblist: [], // 营业执照
      isClear: false,
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      tablelist1: [],
      columns2: [
        {
          type: "selection",
          width: 100,
          fixed: "left"
        },
        {
          title: "代理商UUID",
          key: "agent_uuid",
          minWidth: 100
        },
        {
          title: "名称",
          key: "name",
          minWidth: 160
        }
      ],
      columns2List: [],
      pages1: {
        page: 1,
        size: 10
      },
      pages2: {
        page: 1,
        size: 10
      },
      search_s: {},
      list: [
        {
          title: "用户ID",
          key: "agent_uuid",
          minWidth: 150
        },
        {
          title: "电话",
          key: "username",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.agent != null ? params.row.agent.phone : ""
            );
          }
        },
        {
          title: "用户名称",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h(
              "span",
              params.row.agent != null ? params.row.agent.name : ""
            );
          }
        },
        {
          title: "云支付分销比例",
          key: "underline_fx",
          width: 160,
          render: (h, params) => {
            return h("span", params.row.underline_fx + "%");
          }
        },
        {
          title: "商城分销比例",
          key: "on_fx",
          width: 160,
          render: (h, params) => {
            return h("span", params.row.on_fx + "%");
          }
        },
        {
          title: "二维码",
          key: "registe_at",
          minWidth: 300,
          render: (h, params) => {
            var a = "";
            if (
              params.row.agent.userdata != null &&
              params.row.agent.userdata.username != null
            )
              a = params.row.agent.userdata.username;
            var b = "";
            if (params.row.agent.company != null) b = params.row.agent.company;
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "纯二维码："
              ),

              h(
                "a",
                {
                  attrs: {
                    href:
                      this.$publicData.ossUrl + params.row.agent.qrcode,
                    target: "_blank"
                  },
                  style: {
                    color: "#3c763d"
                  }
                },
                this.$publicData.ossUrl + params.row.agent.qrcode
              ),

              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "合成的纯二维码："
              ),
              h(
                "a",
                {
                  attrs: {
                    href:
                      this.$publicData.ossUrl +
                      params.row.agent.hbqrcode,
                    target: "_blank"
                  },
                  style: {
                    color: "#3c763d"
                  }
                },
                this.$publicData.ossUrl + params.row.agent.hbqrcode
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "定制小程序二维码："
              ),
              h(
                "a",
                {
                  attrs: {
                    href: this.$publicData.ossUrl + params.row.customadeqrcode,
                    target: "_blank"
                  },
                  style: {
                    color: "#3c763d"
                  }
                },
                this.$publicData.ossUrl + params.row.customadeqrcode
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "商城小程序二维码："
              ),
              h(
                "a",
                {
                  attrs: {
                    href: this.$publicData.ossUrl + params.row.newprogramqrcode,
                    target: "_blank"
                  },
                  style: {
                    color: "#3c763d"
                  }
                },
                this.$publicData.ossUrl + params.row.newprogramqrcode
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 350,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              // h(
              //   "Button",
              //   {
              //     style: {
              //       marginRight: "8px"
              //     },
              //     props: {
              //       type: "error",
              //       size: "small"
              //     },
              //     on: {
              //       click: () => {
              //         this.remove(params.row.park_uuid, params.row.agent_uuid);
              //       }
              //     }
              //   },
              //   "删除"
              // ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.agent_uuid);
                    }
                  }
                },
                "提成比例设置"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.egentdetail(params.row.agent_uuid);
                    }
                  }
                },
                "编辑"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      dataInfo: {
        underline_fx: 100,
        on_fx: 100
      },
      dataInfoValidate: {
        underline_fx: [
          { required: true, validator: validateUnderlineFx, trigger: "blur" }
        ],
        on_fx: [{ required: true, validator: validateOnFx, trigger: "blur" }]
      },
      agentsValidate: {
        name: [{ required: true, message: "姓名必须填写", trigger: "change" }],
        type: [
          {
            required: true,
            message: "请选择代理类型",
            trigger: "change",
            type: "integer"
          }
        ],
        describe: [
          { required: true, message: "简介必须填写", trigger: "change" }
        ],
        imageface: [
          { required: true, message: "请上传身份证正面", trigger: "change" }
        ],
        imageback: [
          { required: true, message: "请上传身份证反面", trigger: "change" }
        ],
        company_photo: [
          { required: true, message: "请上传营业执照", trigger: "change" }
        ]
      },
      showModalStatus3: false,
      showModalStatus4: false
    };
  },
  created: function () {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  watch: {
    "$route.params.id": function (curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function () {
      this.$api.park
        .agentlist({
          page: this.pages.page,
          size: this.pages.size,
          id: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.park.agentlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    createAgentTradesMan () {
      this.search_s.key = "";
      this.showModalStatus = true;
      this.$api.park.noBindAgents({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 筛选
    renderTable1: function (name) {
      if (name != 1) {
        this.pages1.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.search_s.key,
        page: this.pages1.page,
        size: this.pages2.size,
        id: this.id
      };
      this.$api.park.noBindAgents(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages2.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    handleSelectRow (selection, index) {
      this.selected = this.$refs.selection.getSelection();
      console.log(this.selected);
    },
    //选中提交
    ok () {
      this.tablelist1 = this.selected;
      this.$api.park
        .agentCreate({ park_uuid: this.id, agentUuidArrs: this.selected })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.$Message.success(res.msg);
            this.showModalStatus = false;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    changePage1 () {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    },
    //更改分销比例
    detail (agent_uuid) {
      this.dataInfo = {
        underline_fx: 100,
        on_fx: 100
      };
      this.$refs["dataInfoValidate"].resetFields();
      this.showModalStatus3 = !this.showModalStatus3;
      this.$api.park
        .agentDetail({ park_uuid: this.id, agent_uuid: agent_uuid })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.dataInfo = res.result;
            this.$Message.success(res.msg);
          }
        });
    },
    // 代理商详情
    egentdetail (index) {
      this.agents = {
        id: null,
        nickname: "",
        phone: "",
        name: "",
        type: 0,
        in_type: 0,
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      };
      this.imagefacethumblist = [];
      this.imagebackthumblist = [];
      this.thumblist = [];

      this.$refs["agentsValidate"].resetFields();

      this.showModalStatus4 = !this.showModalStatus4;
      this.agents.id = index;
      this.$api.agents.detail({ id: index }).then(res => {
        this.agents.id = res.result.agent_uuid;
        this.agents.name = res.result.name;
        this.agents.nickname = res.result.userdata.nickname;
        this.agents.type = res.result.type;
        this.agents.in_type = res.result.in_type;
        this.agents.phone = res.result.phone;
        this.agents.describe = res.result.describe;
        this.agents.status = res.result.status;
        let imgsArr =
          res.result.image == null ? [] : res.result.image.split(",");
        for (var i = 0; i < imgsArr.length; i++) {
          if (i == 0) {
            this.agents.imageface = res.result.image.split(",")[0];
            this.imagefacethumblist.push({
              name: res.result.image.split(",")[0],
              url: res.result.image.split(",")[0],
              status: "finished"
            });
          }

          if (i == 1) {
            this.agents.imageback = res.result.image.split(",")[1];
            this.imagebackthumblist.push({
              name: res.result.image.split(",")[1],
              url: res.result.image.split(",")[1],
              status: "finished"
            });
          }
        }

        this.agents.company_photo = res.result.company_photo;
        if (res.result.company_photo != null) {
          this.thumblist.push({
            name: res.result.company_photo,
            url: res.result.company_photo,
            status: "finished"
          });
        }
      });
    },
    // 修改代理商信息
    editagentinfo (name) {
      if (this.$refs["imagefaceuploadthumb"].uploadList.length > 0) {
        this.agents.imageface = this.$refs[
          "imagefaceuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageface = "";
      }
      if (this.$refs["imagebackuploadthumb"].uploadList.length > 0) {
        this.agents.imageback = this.$refs[
          "imagebackuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageback = "";
      }
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.agents.company_photo = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.agents.company_photo = "";
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {};
          params.id = this.agents.id; //是	string	代理商户UUID
          params.type = this.agents.type; //是	int	商户类型1导游2民宿3景点
          params.in_type = this.agents.in_type;
          params.name = this.agents.name; //否	string	姓名
          params.status = this.agents.status; //否	string	审核状态
          params.describe = this.agents.describe; //否	string	简介
          params.image = this.agents.imageface + "," + this.agents.imageback; //否	string	身份证正反图集
          params.company_photo = this.agents.company_photo; //否	string	营业执照
          this.$api.agents.edit(params).then(res => {
            // console.log(this.agents);
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus4 = !this.showModalStatus4;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //修改分销比例
    editAgent (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$nextTick(() => {
            this.loading = true;
          });
          this.$api.park.agentEdit(this.dataInfo).then(res => {
            if (res.code == 200) {
              this.renderTable(1);
              this.showModalStatus3 = !this.showModalStatus3;
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function (park_uuid, agent_uuid) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.park
            .agentRemove({ agent_uuid: agent_uuid, park_uuid: park_uuid })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
